<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-14 10:39:18
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-12 18:57:46
 * @FilePath: \website\src\components\mobile\cpt-input.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
    <t-form-item :label="option.attribute.label" class="my_input" :style="setStyles">
      <m-input class="my_input_item" :class="option.attribute.labelAlign" v-model="iptVal" :style="setStyles" :placeholder="option.attribute.placeholder"
        :size="option.attribute.size" @blur="clickHandler"  @change="changeInput" :status="message" :align="option.attribute.align" clearable
        :tips="tips"/>
    </t-form-item>
  </t-form>
  <!--  -->
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { getDefaultValue } from "@/utils/refresh-cpt-data";
// import "tdesign-mobile-vue/dist/tdesign.css"
import { Input as MInput} from 'tdesign-mobile-vue';
import { mixinsCom } from "@/mixins/globalAllComps";
// import "tdesign-mobile-vue/es/style/index.css";
// import "tdesign-mobile-vue/es/input/style";


export default {
  name: "cpt-input-mobile",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
    components: Array,
  },
  mixins: [mixinsCom], 
  computed: {
    setStyles() {
      return {
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--labelWidth":this.option.attribute.labelWidth + "px",
        "--labelBoolean":this.option.attribute.labelBoolean ? 'block':'none',
        "--marginLeft":this.option.attribute.labelBoolean && this.option.attribute.labelAlign  != 'top' ?  this.option.attribute.labelWidth + "px" : '0px',
      }
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  components: {
    'm-input': MInput
  },
  data() {
    return {
      message: "default",
      tips: "",
      // iptVal: '',
      // newData: "",
      // jsFunFlag: false,
      uuid:null,
    }
  },
  // watch: {

  //   // 'option.attribute': {
  //   //   handler(obj) {
  //   //      this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
  //   //       const defaultValue = getDefaultValue(obj)
  //   //       if (defaultValue) {
  //   //         this.iptVal = defaultValue
  //   //       }
  //   //   },
  //   //   deep: true
  //   // }
  // },
  created() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    const defaultValue = getDefaultValue(this.option.attribute)
    if (defaultValue) {
      this.iptVal = defaultValue
    }

    this.uuid = require("uuid").v1();
    if (!this.option.attribute.cptTableData) {
      this.option.attribute.cptTableData = [{ "name": "值", "value": "", "namekey": "value" }];
    }
       if (!this.option.cptDataForm) {
      this.option.cptDataForm = {
        dataText: '{"value":""}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    };
    }
    if (this.dataReload.includes(0)) {
      if(this.option.cptDataForm.resData){
        this.processData(this.option.cptDataForm, this.option.cptDataForm.resData, this.option.cptDataForm.jsFunFlag);
      }else{
        this.refreshCptData();
      }
    }
  },
  methods: {
   refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
              //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = res.value;
      }
    },
    clickHandler() {
      this.checkValue();
      this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-input-mobile');
    },
    /**
     * @title 输入时做些什么
     * @desc 通过关联父级组件id调用父级组件的获取inoput框子级参数
     * @param option.attribute.parentId 关联父级的组件id
     * @param getComponentParams  关联父级自定义函数
     */

    changeInput(value) {
      this.checkValue();
      //       if (this.$route.name != "design"){
      //   if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      //     console.log('input')
      //     this.showHideMethod(value);
      //   }
      // }
      // let parentId = this.option.attribute.parentId
      // if (!parentId) {
      //   return
      // }
      // this.refMap[parentId].getComponentParams(this.iptVal)
    },
    enter() {
       console.log('enter')
           this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-input-mobile'); 
    },
        showHideMethod(val) {
    console.log(val,'val')
      if(val != '') {
       if(Array.isArray(this.components) && this.components.length > 0) {
          this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = false;
            }
            if(this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
              item.cptShow = false;
            }
             if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = false;
            }
         });
       }
      } else {
        if(Array.isArray(this.components) && this.components.length > 0) {
         this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = true;
            }
            if(this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
                item.cptShow = true;
            }
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = true;
            }
         });
        } 
       }
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      if (attribute.required && !this.iptVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必填`;
    },
    getValue() {
      console.log(this.iptVal, 'cptVal')
      return this.iptVal
    },
    setValue(value) {
      this.iptVal = value
    },
  }
}
</script>
<style>
/* @import 'tdesign-mobile-vue/es/style/index.css'; */
</style>
<style scoped>
/* 在组件内引入样式文件 */
/* @import 'tdesign-mobile-vue/es/style/index.css'; */
.my_input /deep/ .t-form__label {
   color:var(--textColor);
   font-style: var(--fontStyle);
   font-weight: var(--fontWeight);
   font-family: var(--fontFamily);
   font-size: var(--fontSize);
   line-height: var(--height);
   width:var(--labelWidth) !important;
  display:var(--labelBoolean);
}

:deep(.t-form__controls) {
    margin-left:var(--marginLeft) !important;
}

.my_input /deep/ .t-form__controls {
  margin-left: 0px !important;
}

.my_input /deep/ .t-input .t-input__control::placeholder {
   color: var(--placholderColor); 
 }
.my_input /deep/ .t-input--border::after {
   height: 0px;
 }

.my_input /deep/ .t-input .t-input__control {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_input /deep/ .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  min-height: var(--height);
}

.my_input /deep/.t-input:focus {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_input /deep/.t-input:hover {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_input /deep/.t-input--focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_input /deep/.t-is-focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

</style>